import { SVGProps } from 'react';
import cn from 'classnames';

import Link from '@/components/renderers/Link';

interface PersonaLinkProps {
  href: string;
  title: string;
  subTitle?: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  className?: string;
  variant: 'purple' | 'rose' | 'blue';
}

const iconVariants = {
  purple: `bg-faded-cornflower text-cornflower group-hover:bg-cornflower group-hover:text-white`,
  rose: `bg-lavender-blush text-rose group-hover:bg-rose group-hover:text-white`,
  blue: `bg-faded-blue text-strong-blue group-hover:bg-strong-blue group-hover:text-white`,
};

const linkVariants = {
  purple: `hover:text-cornflower lg:hover:bg-faded-cornflower`,
  rose: `hover:text-rose lg:hover:bg-lavender-blush`,
  blue: `hover:text-strong-blue lg:hover:bg-faded-blue`,
};

const arrowColors = {
  purple: `text-cornflower`,
  rose: `text-rose`,
  blue: `text-strong-blue`,
};

export default function PersonaLink({
  href,
  title,
  subTitle,
  icon: Icon,
  className,
  variant,
}: PersonaLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        `text-haiti transition-colors flex items-center group rounded-lg lg:px-3 lg:py-2 lg:min-h-[60px]`,
        className,
        linkVariants[variant],
      )}
    >
      <div
        className={cn(
          `flex-shrink-0 w-6 h-6 lg:w-10 lg:h-10 rounded flex items-center justify-center transition-colors duration-100`,
          iconVariants[variant],
        )}
      >
        <Icon className="text-[color:inherit] transition-colors duration-75 w-3 h-3 lg:w-[22px] lg:h-[22px]" />
      </div>
      <div className="ml-3 flex items-center justify-between w-full">
        <div>
          <span className="block text-[13px] font-medium">{title}</span>
          {subTitle && (
            <span className="hidden lg:block text-light-haiti text-xs">
              {subTitle}
            </span>
          )}
        </div>
        <span
          className={cn(
            `hidden lg:inline-block invisible group-hover:visible text-xl`,
            arrowColors[variant],
          )}
        >
          &#8594;
        </span>
      </div>
    </Link>
  );
}
